var _mask, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTongyongRenwu1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tongyong_renwu1_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 3a1 1 0 011-1h10a1 1 0 011 1v10a1 1 0 01-1 1H3a1 1 0 01-1-1V3z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 4.5a.5.5 0 000 1v-1zm12 1a.5.5 0 000-1v1zM5.854 8.146a.5.5 0 10-.708.708l.708-.708zm1.767 2.475l-.353.354.353.353.354-.353-.354-.354zM11.44 7.51a.5.5 0 10-.707-.707l.707.707zM2 5.5h12v-1H2v1zm3.146 3.354l2.122 2.12.707-.706-2.121-2.122-.708.708zm2.829 2.12L11.44 7.51l-.707-.707-3.465 3.465.707.707zM3 3h10V1H3v2zm10 10H3v2h10v-2zM3 13V5H1v8h2zm0-8V3H1v2h2zm10-2v2h2V3h-2zm0 2v8h2V5h-2zM3 13H1a2 2 0 002 2v-2zm10 2a2 2 0 002-2h-2v2zm0-12h2a2 2 0 00-2-2v2zM3 1a2 2 0 00-2 2h2V1z",
    fill: "#3F465C",
    mask: "url(#tongyong_renwu1_svg__a)"
  })));
}
export default __webpack_public_path__ + "static/tongyong_renwu1.c8daf7e8.svg";
export { SvgTongyongRenwu1 as ReactComponent };